import $ from 'jquery';
//import "lightslider/dist/js/lightslider";
import 'lightgallery/src/js/lightgallery';
import "slick-carousel/slick/slick.min";
import mapMarkerImage from "../../images/buyMap/map-marker.png";

"use strict";
!function (t) {
    t(document).ready(function () {
        window.onscroll = function () {
            !function () {
                window.pageYOffset + n + a + o.height() + 2 * s,
                window.pageYOffset <= f - a && (e.fadeOut(400),
                    o.css({
                        position: "absolute",
                        top: "-85px"
                    }));
                window.pageYOffset > f - a && (e.fadeIn(400),
                    o.css({
                        position: "fixed",
                        top: "130px"
                    }))
            }(),
            t(window).width() > 767 && window.pageYOffset + n + a + o.height() + 2 * s >= c - a && "absolute" !== o.css("position") && (o.css("position", "absolute"),
                o.css("top", function () {
                    return (c - r - a - o.height() - 2 * s)
                }))
        }
        ;
        var e = t(".apartment-navbar")
            , n = t(".apartment-navbar").height()
            , o = t(".agent-card")
            , s = 16
            , a = 20
            , i = t(".acf-map-apartment-card")
            , f = null
            , u = t(".apartment-section-8")
            , c = null
            , p = t(".apartment-section-2")
            , r = null;
        t.setOffsetsTop = function () {
            setTimeout(function () {
                f = i.offset().top,
                    c = u.offset().top,
                    r = p.offset().top
            }, 200)
        }
            ,
            t.setOffsetsTop();
    })
}(jQuery);

!function(t) {
    t(document).ready(function() {
        var e = t(".slick")
            , a = t(".google-map")
            , n = 0
            , s = t(".apartment-address").text().split(",");
        s.splice(1, 1),
            s = s.join();
        var i = '<div class="gallery-toolbar circularstd-medium"><span class="gallery-toolbar__address">' + s + '</span>|<span class="gallery-toolbar__cost">' + t(".apartment-price").text();
            i += (t("#roomValue").text() !== "" ?'</span>|<span class="gallery-toolbar__beds">' + t("#roomValue").text() + " "+t("#roomText").text() : "asd"),
            i += (t("#bedroomValue").text() !== "" ? '</span>|<span class="gallery-toolbar__beds">' + t("#bedroomValue").text() + " "+t("#bedroomText").text() : ""),
            i += '</span>|<span class="gallery-toolbar__baths">' + t(".apartment-bathrooms").text() + " "+t(".bathrooms-text").text(),
            i += '</span>|<span class="gallery-toolbar__size">' + t(".apartment-sqm").text() + " "+t(".sqm-text").text()+ "</span></div>";
        e.on("onBeforeOpen.lg", function() {
            t("body").addClass("overflow-hidden")
        }),
            e.on("onAfterOpen.lg", function() {
                t('<span class="lg-toogle-thumb lg-icon"></span>').insertAfter("#lg-zoom-out"),
                "Sold" === t(".sold-status").val() && t('<div class="sold sold--gallery">sold</div>').insertBefore(".lg"),
                    t(".lg-toogle-thumb").click(function() {
                        t(".lg-outer").toggleClass("lg-thumb-open")
                    }),
                    t('<span class="lg-open lg-open_map lg-icon"></span>').insertAfter("#lg-zoom-out"),
                    t(".lg-open_map").click(function() {
                        e.data("lightGallery").destroy(!1),
                            setTimeout(function() {
                                a.trigger("click")
                            }, 200)
                    }),
                    t(i).insertAfter("#lg-counter"),
                    t(".lg-item").append('<div class="lg-dont-download"></div>'),
                t(window).width() <= 576 && setTimeout(function() {
                    t(".lg-dont-download").on("click touchstart", function() {
                        t(".lg-outer").toggleClass("lg-hide-items lg-thumb-open")
                    })
                }, 1e3)
                setTimeout(function() {
                    t(".lg-outer").removeClass("lg-thumb-open")
                }, 2000)
            }),
            e.on("onAfterSlide.lg", function(t, e, a) {
                n = a
            }),
            e.on("onBeforeClose.lg", function(e) {
                t("body").removeClass("overflow-hidden")
                    /*lightSlider.slick("slickGoTo", n - 1)*/
            });
        var o = t(window).width() < 767 ? "100%" : "80%";

        if(document.querySelector('.slick-track')){
                a.lightGallery({
                    selector: "this",
                    iframeMaxWidth: o,
                    closable: !1,
                })
            }

            a.on("onBeforeOpen.lg", function() {
                t("body").addClass("overflow-hidden")
            }),
            a.on("onAfterOpen.lg", function() {
                t('<span class="lg-open lg-open_gallery lg-icon"></span>').insertAfter("#lg-zoom-out"),
                    t(i).insertAfter("#lg-counter"),
                    t(".lg-open_gallery").click(function() {
                        a.data("lightGallery").destroy(!1),
                            setTimeout(function() {
                                t(".slick").find('img[data-id="' + n + '"]').trigger("click")
                            }, 200)
                    })
            }),
            a.on("onBeforeClose.lg", function(e) {
                t("body").removeClass("overflow-hidden")
            })
    })
}(jQuery);
$(function () {
   /* $(".slick").on("init", function (e, a) {
        console.log("ide lép?");
        $(".slick").lightGallery({
            selectWithin: ".slick-slide",
            selector: ".js-gallery-img",
            closable: !1
        })
    });*/
    $(".slick").lightGallery({
        share: false,
        download: false,
        closable: !1,
        autoplayControls:false,
        fullScreen: false,
        toogleThumb: true,
    });
    var lightSlider = $(".slick").slick({
        infinite: !0,
        dots: !1,
        variableWidth: !0,
        draggable: !1,
        nextArrow: '<i class="fas fa-chevron-circle-right"></i>',
        prevArrow: '<i class="fas fa-chevron-circle-left"></i>',
        accessibility: !0
    });

    $(document).on("keydown", function (t) {
        37 == t.keyCode && lightSlider.slick("slickPrev"),
        39 == t.keyCode && lightSlider.slick("slickNext")
    });

    $(document).find(".slick-list").attr("tabindex", 0).focus();

    $(".js-open-lg-images").click(function () {
        $('.slick img[data-id="0"]').trigger("click")
    });

    $(document).find(".slick-cloned").on("click", function () {
        $('.slick .slick-slide:not(".slick-cloned") img[data-id="' + $(this).find("img").data("id") + '"]').trigger("click")
    });

    $(".js-open-lg-floorplan").click(function () {
        $('.slick img[data-id="floorplan-image"]').trigger("click")
    });


    initMap();
    var $body = $("body");

    $body.on("click","#agent-footer-form-close",function(){
        $(".agent-footer").removeClass("show")
    });

    $body.on("click","#agent-footer-form-close",function(){
        $(".agent-footer").removeClass("show");
        const button = $("#footer-contact-agent-button");
        button.data("status","base");
        button.html(button.data("base-text"));
        $body.removeClass("body-no-scroll");
    });

    $body.on("click","#footer-contact-agent-button",function(){
        const dataStatus = $(this).data("status");
        if(dataStatus === "base"){
            $(".agent-footer").addClass("show");
            $(this).data("status","form");
            $(this).html($(this).data("send-text"));
            $body.addClass("body-no-scroll");
        }else{
            //$("#send-to-agent-form-footer").trigger("submit");
        }

    });

    $body.on("click","#contact-Agent",function(){
        $(".agent-form").addClass("d-block");
        $("#contact-agent-button-container").hide();
        $("#send-contact-agent-container").removeClass("d-none");
        setTimeout(() => {
            $(".agent-form").addClass("show");
        },1)
    });
    $body.on("click","#agent-form-close",function(){

        $(".agent-form").removeClass("show");
        setTimeout(function(){
            $(".agent-form").removeClass("d-block");
            $("#contact-agent-button-container").show();
            $("#send-contact-agent-container").addClass("d-none");
        },200);
    });

});


const initMap = () => {
    if (typeof google === "undefined") {
        return
    }

    const $mapsContainer = $('#buyApartmentMap');
    const map = new google.maps.Map($mapsContainer[0], {
        center: new google.maps.LatLng(parseFloat($mapsContainer.data("lat")), parseFloat($mapsContainer.data("lng"))),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{featureType: "poi", stylers: [{visibility: "off"}]}],
        disableDefaultUI: !0,
        zoom: 17
    });

    const marker =  new google.maps.Marker({
        icon: mapMarkerImage,
        label: ".",
        position: {
            lat: parseFloat($mapsContainer.data("lat")),
            lng: parseFloat($mapsContainer.data("lng"))
        },
    });
    new MarkerClusterer(
        map,
        [marker],{
            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        }
    );
};
